import React, { useState } from "react";
import './styles.scss';
import DATA from 'utils/data.json';

const QNA_DATA = DATA.qna;

const Qna = () => {
    const [currentQ, setCurrentQ] = useState(0);

    return (
        <section id='qna-id' className="qna-block container">
            <p className="title">{QNA_DATA.title}</p>
            <img alt='' src={'/images/qna-image.png'} className='image' />
            <div className="content">
                {QNA_DATA.list.map((qna, index) => {
                    return (
                        <button className={`item ${currentQ === index ? 'active' : ''}`} key={index} onClick={() => setCurrentQ(index)}>
                            <div className={`q ${currentQ === index ? 'active' : ''}`}>
                                <p>{qna.q}</p>
                                {currentQ === index ?
                                    <div className="plus"><span>+</span></div>
                                    :
                                    <div className="minus"><span>-</span></div>
                                }
                            </div>
                            {currentQ === index &&
                                <div className="a">
                                    <p dangerouslySetInnerHTML={{__html: qna.a}}/>
                                </div>
                            }
                        </button>
                    )
                })}
            </div>
        </section>
    )
}

export default Qna